/* eslint-disable import/prefer-default-export */
const API_CONFIG = {
  SKU_DATA_DB_ENDPOINT: "http://localhost:4000",
  S3_UPLOAD_ENDPOINT: "https://d1j8b9hqcdho5v.cloudfront.net",
  SKU_DATA_S3_ENDPOINT: "https://demj0ontputmf.cloudfront.net",
  GA_TRACKING_ID: "G-RMVRVBD7LG",
  ENABLE_LOGS: true,
  MIXPANEL_PROJECT_TOKEN: "1fde521278c720f7703bb7175145fd43"
};

export { API_CONFIG };
